import type { World } from "../../../render/world/World";
import type { BoardUpdate } from "./BoardUpdate";
import { type BoardWorldObject, isBoardWorldObject } from "./BoardWorldObject";

export class BoardUpdateQueue {
  private readonly waitingUpdates: BoardUpdate[] = [];
  private readonly world: World;

  constructor(world: World) {
    this.world = world;
  }

  add(boardUpdate: BoardUpdate) {
    this.waitingUpdates.push(boardUpdate);
  }

  startNextUpdateIfReady(): BoardUpdate | null {
    const boardWorldObjects = this.boardWorldObjects();
    const allFinished = boardWorldObjects.every((boardWorldObject) => boardWorldObject.isBoardUpdateFinished());
    if (!allFinished) return null;

    const boardUpdate = this.waitingUpdates.shift();
    if (!boardUpdate) return null;

    for (const boardWorldObject of boardWorldObjects) {
      boardWorldObject.onBoardUpdate(boardUpdate);
    }
    return boardUpdate;
  }

  private boardWorldObjects(): BoardWorldObject[] {
    return [...this.world.getObjects()].filter(isBoardWorldObject);
  }
}
